import {ShiftSummaryPage as ShiftSummaryPageFeature} from '@features/shift-summary'
import {STOPPAGE_ANALYSIS_SUB_PATH} from '@features/stoppage-analysis'
import {hproduce} from '@hconnect/common/hproduce/config/hproduce'
import {DateRange} from '@hconnect/common/types'
import {getHost, toTimeRange} from '@hconnect/common/utils'
import {useCallback} from 'react'
import {generatePath, useNavigate, useParams} from 'react-router'

export const ShiftSummaryPage = () => {
  const {plantId} = useParams<{plantId: string}>()
  if (!plantId) throw new Error('plantId is required')

  const navigate = useNavigate()
  const hproduceOrigin = getHost(hproduce.url)
  const dashboardUrl = `${hproduceOrigin}/downtime/${plantId}`

  const onEquipmentClick = useCallback(
    (equipmentId: string, dateRange: DateRange) => {
      const stoppageAnalysisSubPath = generatePath(STOPPAGE_ANALYSIS_SUB_PATH, {equipmentId})
      const timeRange = toTimeRange([dateRange.startDate, dateRange.endDate])
      const range = encodeURIComponent(`[${timeRange.startDate},${timeRange.endDate}]`)

      void navigate(`${stoppageAnalysisSubPath}?timeRange=${range}`)
    },
    [navigate]
  )

  return (
    <ShiftSummaryPageFeature
      plantId={plantId}
      dashboardUrl={dashboardUrl}
      onEquipmentClick={onEquipmentClick}
      inverted
    />
  )
}
